

















import { Vue, Component, Prop } from 'vue-property-decorator';
import { debouncedSaveArticle, debouncedSaveData } from '../../utils/utils';
@Component({
  
})
export default class BgVolume extends Vue {
  volume: number = 0.5;
  voluemSliderChange() {
    debouncedSaveArticle(this)
    debouncedSaveData(this)
    this.$emit('change-volume', this.volume)
  }
  confirm() {
    this.$emit('confirm-volume', this.volume)
  }
}
